import '../scripts/app';
import '../scripts/redirectConfig';
import '../scripts/constants';
import '../scripts/controllers';
import '../scripts/directives';
import '../scripts/factories';
import '../scripts/filters';
import '../scripts/services';
import '../components';
import '../styles/main.scss';
